import React, { useState, useRef, useEffect } from 'react';
import './DownloadButton.css';

const DownloadButton = ({ size = 'default' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className={`download-wrapper ${size}`} ref={ref}>
      <button className="download-btn" onClick={() => setOpen(!open)}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        Download Now
        <svg className={`download-chevron ${open ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      <div className={`download-dropdown ${open ? 'show' : ''}`}>
        <a
          href="https://play.google.com/store/apps/details?id=com.remote.master.universal"
          target="_blank"
          rel="noopener noreferrer"
          className="download-option"
          onClick={() => setOpen(false)}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92z" fill="#4285F4"/>
            <path d="M17.556 8.236L5.178.904a1.003 1.003 0 00-1.07.018l9.89 9.89 3.558-2.576z" fill="#34A853"/>
            <path d="M17.556 15.764l-3.558-2.576-9.89 9.89a1.003 1.003 0 001.07.018l12.378-7.332z" fill="#FBBC04"/>
            <path d="M20.778 10.906l-3.222-1.91-3.764 2.724 3.764 2.724 3.222-1.91a1.19 1.19 0 000-1.628z" fill="#EA4335"/>
          </svg>
          <div className="download-option-text">
            <span className="download-option-label">Android</span>
            <span className="download-option-sub">Google Play Store</span>
          </div>
        </a>
        <a
          href="https://apps.apple.com/app/id6760695054"
          target="_blank"
          rel="noopener noreferrer"
          className="download-option"
          onClick={() => setOpen(false)}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
          <div className="download-option-text">
            <span className="download-option-label">iOS</span>
            <span className="download-option-sub">Apple App Store</span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default DownloadButton;
